import { isoString, systemClock, type Clock } from "../time.js";
import type { Topic, TopicPatch } from "./types.js";

/** Apply a patch and bump updated_at. Immutable: returns a new object. */
export function updateTopic(topic: Topic, patch: TopicPatch, now: Clock = systemClock): Topic {
  return {
    ...topic,
    ...patch,
    id: topic.id,
    created_at: topic.created_at,
    updated_at: isoString(now()),
  };
}

/** Soft-delete: sets deleted_at without removing the row. */
export function softDeleteTopic(topic: Topic, now: Clock = systemClock): Topic {
  const ts = isoString(now());
  return { ...topic, deleted_at: ts, updated_at: ts };
}
